import { lazy } from "react";

// import Alternative from 'views/pages/dashboards/Alternative.js';

// const Dashboard = lazy(() => import('views/pages/dashboards/Dashboard'));
// const Summary = lazy(() => import('views/pages/client/summary'));
const DetailClient = lazy(() => import("views/pages/client/detail"));
const Debt = lazy(() => import("views/pages/client/debt"));
const Addlead = lazy(() => import("views/pages/lead"));
const RecentClients = lazy(() => import("views/pages/recentClients"));
const DebtVerify = lazy(() => import("views/pages/client/debtVerify"));
const ClientAudit = lazy(() => import("views/pages/client/audit"));
const CostStructure = lazy(() => import("views/pages/client/costStructure"));
const Draft = lazy(() => import("views/pages/client/drafts"));
const CurrentDraft = lazy(() => import("views/pages/client/currentDraft"));
const SearchLeads = lazy(() => import("views/pages/searchLeads"));
const funds = lazy(() => import("views/pages/client/funds"));
const QuickCost = lazy(() => import("views/pages/quickCostCalculator"));
const SearchClients = lazy(() => import("views/pages/searchClients"));
const SearchMailings = lazy(() => import("views/pages/searchMailings"));
const SharkTank = lazy(() => import("views/pages/sharkTank"));
const ClientDocuments = lazy(() => import("views/pages/client/documents"));
const Financial = lazy(() => import("views/pages/client/financial"));
const AppointmentGeneral = lazy(() =>
  import("views/pages/appointment/generalEvents")
);
const AppointmentClient = lazy(() =>
  import("views/pages/appointment/clientEvents")
);
const Docusign = lazy(() => import("views/pages/client/docusign"));

const ClientCare = lazy(() => import("views/pages/client/clientCare"));
const ImportCampaign = lazy(() => import("views/pages/importCampaign"));
const AffiliateUsers = lazy(() => import("views/pages/affiliateUsers"));
const SalesPipeline = lazy(() => import("views/pages/salesPipeline"));
const ClientWebhook = lazy(() => import("views/pages/client/webhook"));
const DMDetailClient = lazy(() => import("views/pages/client/dmApp"));


const anyRole = ["any"];
const customerAdminrole = [
  "CustomerAdministrator",
  "CustomerRepresentative",
  "SalesRepresentative",
  "Affiliate",
  "SalesRepSupervisor",
  "CustomerRepSupervisor",
  "Negotiator",
  "NegotiatorSupervisor",
  "AffiliateSales",
  "AffiliateReports",
  "AffiliateAdmin",
  "AffiliateMailingSearch",
  "LiveUnderwritingSales",
  "LiveUnderwritingSalesSupervisor",
  "AffiliateLead"
];

// const affiliateRole = ["AffiliateSupervisor"];
const affiliateRole = ["AffiliateAdmin"];

///const salesrole = ["SalesMan"];
// const clientManagementAccessNoAffiliateReports =["customeradministrator","customerrepresentative","salesrepresentative",
// "negotiator","affiliatesales","negotiatorsupervisor","customerrepsupervisor","salesrepsupervisor","affiliatesupervisor","attorney","liveunderwritingsales","liveunderwritingsalessupervisor"];

export const DashboardRoutes = [
  {
    path: "/quick/cost/calculator",
    name: "Quick Cost Calculator",
    icon: "fa fa-calculator text-green",
    component: QuickCost,
    layout: "/admin",
    leftNav: true,
    tab: false,
    roles: customerAdminrole,
    orderBy: 1.1,
  },
  {
    path: "/sharkTank",
    name: "Shark Tank",
    icon: "fa fa-users text-blue",
    miniName: "S",
    component: SharkTank,
    layout: "/admin",
    leftNav: true,
    tab: false,
    roles: customerAdminrole,
    orderBy: 1.2,
  },
  {
    path: "/pipeline",
    name: "Sales Pipeline",
    icon: "fas fa-funnel-dollar text-green",
    miniName: "S",
    component: SalesPipeline,
    layout: "/admin",
    leftNav: true,
    tab: false,
    roles: anyRole,
    orderBy: 1.2,
    redirect: true
  },

  {
    path: "/appointments",
    name: "Appointments",
    icon: "ni ni-calendar-grid-58 text-orange",
    miniName: "S",
    component: AppointmentGeneral,
    layout: "/admin",
    leftNav: true,
    tab: false,
    roles: customerAdminrole,
    orderBy: 1.3,
  },
  {
    path: "/importcampaigns",
    name: "Import Campaigns",
    icon: "fa fa-upload text-green",
    miniName: "S",
    component: ImportCampaign,
    layout: "/admin",
    leftNav: true,
    tab: false,
    roles: affiliateRole,
    orderBy: 1.3,
  },
  {
    path: "/affiliateUsers",
    name: "Affiliate Users",
    icon: "fa fa-users",
    miniName: "AU",
    component: AffiliateUsers,
    layout: "/admin",
    leftNav: true,
    tab: false,
    roles: affiliateRole,
    orderBy: 1.4,
  },
  {
    collapse: true,
    name: "Manage Leads",
    icon: "ni ni-ungroup text-orange",
    state: "dashboardsCollapse12",
    module: "ClientMgmt",
    orderBy: 3,
    views: [
      {
        path: "/addlead",
        name: "Add New",
        miniName: "+N",
        component: Addlead,
        layout: "/admin",
        leftNav: true,
        tab: false,
        roles: customerAdminrole,
        orderBy: 1.0,
      },
      {
        path: "/recentClients",
        name: "Recent List",
        miniName: "R",
        component: RecentClients,
        layout: "/admin",
        leftNav: true,
        tab: false,
        roles: customerAdminrole,
        orderBy: 1.1,
      },
      {
        path: "/searchLeads",
        name: "Search Leads",
        miniName: "SL",
        component: SearchLeads,
        layout: "/admin",
        leftNav: true,
        tab: false,
        roles: customerAdminrole,
        orderBy: 1.3,
      },
      {
        path: "/searchClients",
        name: "Search Clients",
        miniName: "SC",
        component: SearchClients,
        layout: "/admin",
        leftNav: true,
        tab: false,
        roles: customerAdminrole,
        orderBy: 1.4,
      },
      {
        path: "/searchMailings",
        name: "Search Mailer",
        miniName: "SM",
        component: SearchMailings,
        layout: "/admin",
        leftNav: true,
        tab: true,
        roles: customerAdminrole,
        orderBy: 1.5,
      },
    ],
  },
];

export const ClientMgmtRoutes = [
  {
    collapse: true,
    name: "Profile",
    icon: "ni ni-ui-04 text-info",
    state: "tab",
    module: "clientMgmt",
    orderBy: 1,
    parentName: "/profile",
    path: "/profile/detail",
    layout: "/admin/client",
    views: [
      {
        path: "/profile/detail",
        name: "Detail",
        miniName: "A",
        component: DetailClient,
        layout: "/admin/client",
        tab: true,
        subChild: false,
        roles: anyRole,
        parentName: "/profile",
        orderBy: 1.2,
      },
      // {
      //   path: "/profile/otherquestion",
      //   name: "Other Question",
      //   miniName: "A",
      //   component: Other,
      //   layout: "/admin/client",
      //   tab: true,
      //   subChild: false,
      //   roles: clientManagementAccessNoAffiliateReports,
      //   parentName: "/profile",
      //   orderBy: 1.3
      // },
      {
        path: "/profile/financial",
        name: "Financial",
        miniName: "F",
        component: Financial,
        layout: "/admin/client",
        tab: true,
        subChild: false,
        roles: anyRole,
        parentName: "/profile",
        orderBy: 1.3,
      }, {
        path: "/profile/dm_view",
        name: "DMDetail",
        miniName: "A",
        component: DMDetailClient,
        layout: "/admin/client",
        tab: true,
        subChild: false,
        roles: anyRole,
        parentName: "/profile",
        orderBy: 1.4,
      },
    ],
  },
  {
    collapse: true,
    self: true,
    name: "Debt",
    icon: "ni ni-ui-04 text-info",
    state: "tab",
    module: "clientMgmt",
    orderBy: 1,
    parentName: "/debt",
    path: "/debt",
    layout: "/admin/client",
    views: [
      {
        path: "/settlement",
        name: "Settlement",
        miniName: "D",
        component: Debt,
        layout: "/admin/client",
        tab: true,
        subChild: true,
        roles: customerAdminrole,
        orderBy: 1.1,
        parentName: "/debt",
      },
      {
        path: "/debt",
        name: "",
        miniName: "A",
        component: Debt,
        layout: "/admin/client",
        tab: true,
        subChild: true,
        roles: anyRole,
        orderBy: 1.2,
        parentName: "/debt",
      },
      {
        path: "/verify/:hascoapp",
        name: "",
        miniName: "A",
        component: DebtVerify,
        layout: "/admin/client",
        tab: true,
        subChild: true,
        roles: anyRole,
        orderBy: 1.2,
        parentName: "/debt",
      },
    ],
  },

  {
    collapse: true,
    name: "Drafts",
    icon: "ni ni-ui-04 text-info",
    state: "tab",
    module: "clientMgmt",
    orderBy: 3,
    parentName: "/program",
    path: "/program/draft/current",
    layout: "/admin/client",
    views: [
      {
        path: "/program/clientfee",
        name: "Cost Structure",
        miniName: "CS",
        component: CostStructure,
        layout: "/admin/client",
        tab: true,
        subChild: false,
        roles: customerAdminrole,
        parentName: "/program",
        orderBy: 3.1,
      },
      {
        collapse: true,
        name: "Draft",
        icon: "ni ni-ui-04 text-info",
        state: "tab2",
        orderBy: 3.2,
        parentName: "/program/draft",
        path: "/program/draft/calculator",
        layout: "/admin/client",
        views: [
          {
            path: "/program/draft/current",
            name: "Current",
            miniName: "CS",
            component: CurrentDraft,
            layout: "/admin/client",
            tab: true,
            subChild: false,
            roles: customerAdminrole,
            parentName: "/program/draft",
            orderBy: 3.3,
            paymentPage: "yes",
          },
          {
            path: "/program/draft/calculator",
            name: "Add Draft Schedule",
            miniName: "CS",
            component: Draft,
            layout: "/admin/client",
            tab: true,
            subChild: false,
            roles: customerAdminrole,
            parentName: "/program/draft",
            orderBy: 3.4,
          },
        ],
      },
    ],
  },
  {
    collapse: true,
    self: true,
    name: "ACH",
    icon: "ni ni-ui-04 text-info",
    state: "tab",
    module: "clientMgmt",
    orderBy: 1,
    parentName: "/funds",
    path: "/funds/banking",
    layout: "/admin/client",
    views: [
      {
        path: "/funds/banking",
        name: "",
        miniName: "N",
        component: funds,
        layout: "/admin/client",
        tab: true,
        subChild: false,
        roles: anyRole,
        orderBy: 1.1,
        parentName: "/banking",
      },
    ],
  },
  {
    collapse: true,
    self: true,
    name: "History",
    icon: "ni ni-ui-04 text-info",
    state: "tab",
    module: "clientMgmt",
    orderBy: 4,
    parentName: "/history",
    path: "/history/audit",
    layout: "/admin/client",
    tab: true,
    subChild: true,
    roles: anyRole,
    views: [
      {
        path: "/history/audit",
        name: "Notes",
        miniName: "N",
        component: ClientAudit,
        layout: "/admin/client",
        tab: true,
        subChild: true,
        roles: anyRole,
        orderBy: 4.1,
        parentName: "/history",
      },
      {
        collapse: true,
        name: "Documents",
        icon: "ni ni-ui-04 text-info",
        state: "tab2",
        orderBy: 4.2,
        parentName: "/history/document",
        path: "/history/document/documents",
        layout: "/admin/client",
        views: [
          {
            path: "/history/document/documents",
            name: "Documents",
            miniName: "D",
            component: ClientDocuments,
            layout: "/admin/client",
            tab: true,
            subChild: false,
            roles: anyRole,
            parentName: "/history/document",
            orderBy: 4.3,
          },
          {
            path: "/history/document/esignature",
            name: "E-SignatureRequests",
            miniName: "E",
            component: Docusign,
            layout: "/admin/client",
            tab: true,
            subChild: false,
            roles: anyRole,
            parentName: "/history/document",
            orderBy: 4.4,
          },
        ],
      },
      {
        path: "/history/template",
        name: "Templates",
        miniName: "T",
        component: ClientCare,
        layout: "/admin/client",
        tab: true,
        subChild: true,
        roles: anyRole,
        orderBy: 4.5,
        parentName: "/audit",
      },
    ],
  },
  {
    collapse: true,
    self: true,
    name: "Appointments",
    icon: "ni ni-ui-04 text-info",
    state: "tab",
    module: "clientMgmt",
    orderBy: 1,
    parentName: "/appointments",
    path: "/appointments",
    layout: "/admin/client",
    views: [
      {
        path: "/appointments",
        name: "Appointments",
        miniName: "N",
        component: AppointmentClient,
        layout: "/admin/client",
        tab: true,
        subChild: true,
        roles: anyRole,
        orderBy: 1.1,
        parentName: "/audit",
      },
    ],
  }, {
    collapse: true,
    self: true,
    name: "Webhook",
    icon: "ni ni-ui-04 text-info",
    state: "tab",
    module: "clientMgmt",
    orderBy: 1,
    parentName: "/webhook",
    path: "/webhook",
    layout: "/admin/client",
    views: [
      {
        path: "/webhook",
        name: "Webhooks",
        miniName: "N",
        component: ClientWebhook,
        layout: "/admin/client",
        tab: true,
        subChild: true,
        roles: anyRole,
        orderBy: 1.1,
        parentName: "/webhook",
      },
    ],
  },
];
